import ListItemText from '@material-ui/core/ListItemText'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import { withStyles } from '@material-ui/core/styles'
import MoreVert from '@material-ui/icons/MoreVert'
import Button from 'components/CustomButtons/Button.js'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import { deleteProgramSpec } from '../../reduxToolkit/features/program/ProgramSpecSlice.js'
import AccessAndRoleModal from './AccessAndRoleModal.js'
import SuperGeneralDeleteModal from './SuperGeneralDeleteModal.js'
import BaseUrl from '../../assets/utils/accessToken.js'

import VersionControlModal from '../../views/Pages/Specifications/program/VersionControlModal.js'
import VersionControlModal2 from '../../views/Pages/Specifications/program/VersionControlModal2.js'
import { unwrapResult } from '@reduxjs/toolkit'
import { notification } from 'antd'
import ErrorsModal from './ErrorsModal.js'
const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))

export default function ProgramCardDropdownButton(props) {

  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [editDisabled, setEditDisabled] = React.useState(false)
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [open, setOpen] = React.useState(false)
  const [refresh, setRefresh] = React.useState(false)

  const [openErrorModal, setOpenErrorModal] = React.useState(false)
  const [handledError, setHandledError] = React.useState('')

  const handleOpenErrorModal = () => {
    setOpenErrorModal(true)
  }
  const handleCloseErrorModal = () => {
    setOpenErrorModal(false)
  }

  const handleOpenDeleteModal = () => {
    setOpen(true)
  }

  const handleCloseDeleteModal = () => {
    setOpen(false)
  }
  const openNotificationWithIcon = (type, msg) => {
    notification[type]({
      message: type,
      description: msg,
      top: 50,
      duration: 2,
    })
  }

  const handleDeleteProgram = (id) => {

    dispatch(deleteProgramSpec(id))
      .unwrap()
      .then((originalPromiseResult) => {
        // handle result here
        props.fetchProgramsCustomFunction()
        props.fetchProgramsByPageCustomFunction(props.params)
        openNotificationWithIcon('success', `Deleted`)
      })
      .catch((rejectedValueOrSerializedError) => {
        // handle error here
        setHandledError(rejectedValueOrSerializedError)
        handleOpenErrorModal()
      })
  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  useEffect(() => {
    if (props.state === 'Approved' || props.state === 'Waiting for approval') {
      setEditDisabled(true)
    }
  }, [])

  return (
    <div>
      <Button
        // aria-describedby={id}
        aria-controls="customized-menu"
        variant="contained"
        color="primary"
        onClick={handleClick}
        justIcon
        round
        aria-haspopup="true"
      >
        <MoreVert />
      </Button>

      <StyledMenu
        id="customized-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <Link to={`/citrine/updateProgramSpec/${props.id}`}>
          <MenuItem disabled={editDisabled}>
            <ListItemText style={{ color: 'black' }} primary="Edit" />
          </MenuItem>
        </Link>
        {/* <VersionControlModal
          id={props.id}
          handleDropDownButtonClose={handleClose}
          NameOfComponentUsed="Programs"
          interface='progSpec'
          data={props.data}
        /> */}
        {/* <VersionControlModal2
          id={props.id}
          handleDropDownButtonClose={handleClose}
          NameOfComponentUsed="Programs"
          interface="progSpec"
          data={props.data}
          refresh={refresh}
          setRefresh={setRefresh}
        /> */}
        {/**************************************************************************************************************************************************************
         * in 'ProgramCoordinatorModal' Component i am passed 'disabled', 'NameOfComponentUsed' and 'style' as a props to manage this component in different interfaces
         *
         * updated 19/11/2022
         **************************************************************************************************************************************************************/}
        <AccessAndRoleModal
          id={props.id}
          handleDropDownButtonClose={handleClose}
          NameOfComponentUsed="Programs"
          interface="progSpec"
          data={props.data}
          staffList={props.staffList}
        />

        {/*************************************************************************************************************************************************************/}

        {/* <ProgramCoordinatorModal id={props.id} program={props.program} handleDropDownButtonClose={handleClose} /> */}
        <Link
          to={`/citrine/specification/program/${props.id}/accreditationDates`}
        >
          <MenuItem>
            <ListItemText
              style={{ color: 'black' }}
              primary="Edit accreditation dates"
            />
          </MenuItem>
        </Link>
        <MenuItem
          onClick={() => {
            handleOpenDeleteModal()
            handleClose()
          }}
        >
          <ListItemText primary="Delete" />
        </MenuItem>
        <SuperGeneralDeleteModal
          delete_Element={handleDeleteProgram}
          Element_ID={props.id}
          open={open}
          handleClose={handleCloseDeleteModal}
        />
      </StyledMenu>
      <ErrorsModal
        open={openErrorModal}
        handleClose={handleCloseErrorModal}
        handledError={handledError}
      />
    </div>
  )
}
